"use client";

import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { IoArrowUp } from "react-icons/io5";
import AnimatedIcon from "./animated-icon";

interface ScrollToTopProps {
  isDrawerOpen?: boolean;
}

export default function ScrollToTop({
  isDrawerOpen = false,
}: ScrollToTopProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <AnimatePresence>
      {isVisible && !isDrawerOpen && (
        <motion.button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 z-50 w-12 h-12 bg-primary text-white rounded-full shadow-lg hover:shadow-xl transition-shadow duration-300 cursor-pointer flex justify-center items-center"
          initial={{ opacity: 0, scale: 0, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0, y: 20 }}
          whileHover={{
            scale: 1,
            y: -5,
            boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
          }}
          whileTap={{ scale: 0.9 }}
          transition={{
            duration: 0.3,
            ease: "easeOut",
          }}
        >
          <AnimatedIcon animation="hover" className="w-6 h-6 cursor-pointer">
            <IoArrowUp className="w-6 h-6" />
          </AnimatedIcon>
        </motion.button>
      )}
    </AnimatePresence>
  );
}
